import store from '../@store'
import { request, requestFile } from '../@utils'

export default {
  // 获取下拉列表
  getDropDownList: async (tag) => {
    let res = await request.post('order/dropdown-list', { data: { tag } })
    let obj = {}
    obj[tag] = res || []
    store.dispatch({ type: 'order/getParams', payload: obj })
    return res
  },
  queryOrderStatistics: (data) => {
    return request.post('order/query/statistics', { data })
  },
  getOrderList: (data) => {
    return request.post('order/list', { data })
  },
  getOrderDetail: (orgOrderNo) => {
    return request.get('order/info/' + orgOrderNo)
  },
  exportOrder: (data) => {
    return requestFile.post('order/export', { data, responseType: 'blob' })
  },
  orderProductExport: (data) => {
    return requestFile.post('order/orderProductExport', { data, responseType: 'blob' })
  },
  queryAfterSaleStatistics: (data) => {
    return request.post('after-sale/query/statistics', { data })
  },
  getAfterSaleList: (data) => {
    return request.post('after-sale/list', { data })
  },
  getAfterSaleDetail: (afterSaleNo) => {
    return request.get('after-sale/info/' + afterSaleNo)
  },
  getAfterSaleApprove: (data)=>{
    return request.post('after-sale/approve', {data})
  },
  getAfterSaleReject: (data)=>{
    return request.post('after-sale/reject', {data})
  },
  exportAfterSale: (data) => {
    return requestFile.post('after-sale/export', { data, responseType: 'blob' })
  },
  exportAftersaleProduct: (data) => {
    return requestFile.post('after-sale/exportAftersaleProduct', { data, responseType: 'blob' })
  },
  applyReturn: (data) => {
    return request.post('after-sale/apply-return', { data })
  },
  getPayinDailyList: (data) => {
    return request.post('payin/daily-payin/list', { data })
  },
  exportPayinDaily: (data) => {
    return requestFile.post('payin/daily-payin/export', {
      data,
      responseType: 'blob',
    })
  },
  getPayTypes: async () => {
    let res = await request.get('payin/pay-type/list')
    store.dispatch({
      type: 'order/getParams',
      payload: { payTypes: res || [] },
    })
    return res
  },
  getPayinSlipList: (data) => {
    return request.post('payin/payin-slip/item/list', { data })
  },
  exportPayinSlip: (data) => {
    return requestFile.post('payin/payin-slip/item/export', {
      data,
      responseType: 'blob',
    })
  },
  verifyPayinSlip: (data) => {
    return request.post('payin/payin-slip/item/verify', { data })
  },
  rejectPayinSlip: (data) => {
    return request.post('payin/payin-slip/item/reject', { data })
  },
  // 获取订单详情
  afterSaleDetailById: (afterSaleNo) => {
    return request.get('/after-sale/detail/' + afterSaleNo)
  },
  // 发起售后
  createAfterSale: (data) => {
    return request.post('/after-sale/create/aftersale',{ data })
  }
}
